import React, { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useSearchParams } from 'react-router';

import Centered from '../../01_atoms/Centered/Centered';
import Button from '../../01_atoms/Button/Button';
import Loader from '../../01_atoms/Loader/Loader';

function LoginPage() {
  const { activeNavigator, isLoading, error, signinRedirect } = useAuth();
  const [searchParams, _setSearchParams] = useSearchParams();

  useEffect(() => {
    document.title = 'Sweet Bibi - Aanmelden';
  }, []);

  switch (activeNavigator) {
    case 'signinSilent':
      return (
        <main>
          <Centered>
            <span>Je wordt aangemeld</span>
            <Loader />
          </Centered>
        </main>
      );
    case 'signoutRedirect':
      return (
        <main>
          <Centered>
            <span>Je wordt afgemeld</span>
            <Loader />
          </Centered>
        </main>
      );
    default:
    // do nothing
  }

  if (isLoading) {
    return (
      <main>
        <Centered>
          <span>Aan het laden</span>
          <Loader />
        </Centered>
      </main>
    );
  }

  if (error) {
    return (
      <main>
        <Centered>
          <div
            style={{
              maxWidth: '40em',
              color: 'var(--color-error-noon)',
              border: '1px var(--color-error-noon) solid',
              borderRadius: 'var(--border-radius)',
              padding: 'var(--spacing-base)',
            }}
          >
            <h1>Oeps...</h1>
            <p style={{ marginTop: 'var(--spacing-base)', marginBottom: 'var(--spacing-base)' }}>
              {error.message}
            </p>
            <p>Bron: {error.source}</p>
          </div>
        </Centered>
      </main>
    );
  }

  return (
    <main>
      <Centered>
        <Button
          type="primary"
          label="Log in met Microsoft"
          setClicked={() => {
            signinRedirect({ url_state: searchParams.get('redirect') || '' });
          }}
        />
      </Centered>
    </main>
  );
}

export default LoginPage;

